export enum ELanguage {
  'zh' = 'zh',
  'en' = 'en',
  'ar' = 'ar',
  'zh-HK' = 'zh-HK',
  'pt-BR' = 'pt-BR'
}
